import {CDN_IMAGE_URL} from 'configs';
import {isEqual} from 'lodash';
import React from 'react';
import LazyLoad from 'react-lazyload';
import urlJoin from 'url-join';

function HelpSectionVideo({src, loading}) {
  if (isEqual(loading, 'eager')) {
    return (
      <video
        poster={urlJoin(CDN_IMAGE_URL, 'elements/lazy-load-white.webp')}
        preload="none"
        playsInline
        muted
        loop
        autoPlay
        style={{width: '100%', borderRadius: '8px'}}
      >
        <source src={src} type="video/mp4" />
      </video>
    );
  }

  return (
    <LazyLoad height={200}>
      <video
        poster={urlJoin(CDN_IMAGE_URL, 'elements/lazy-load-white.webp')}
        preload="none"
        playsInline
        muted
        loop
        autoPlay
        style={{width: '100%', borderRadius: '8px'}}
      >
        <source src={src} type="video/mp4" />
      </video>
    </LazyLoad>
  );
}

export default HelpSectionVideo;
